import { Navigate, Outlet } from 'react-router'
import { useAuth } from '@/features/auth/AuthContext'
import { ROUTES } from '@/shared/routes'

export const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace />
  return <Outlet />
}
